/*
 * ev-cart-bundle: синхронизатор размера media в .ev-bundle-card.
 * Media — квадрат, его сторона = высоте body карточки.
 */
(function () {
  function syncBundleMedia(card) {
    if (window.matchMedia('(max-width: 749px)').matches) {
      card.style.removeProperty('--ev-bundle-media-size');
      return;
    }
    var body = card.querySelector('.ev-bundle-card__body');
    if (!body) return;
    var size = Math.max(80, Math.round(body.getBoundingClientRect().height));
    card.style.setProperty('--ev-bundle-media-size', size + 'px');
  }

  function bind() {
    var cards = document.querySelectorAll('.ev-bundle-card');
    if (!cards.length) return;
    var hasRO = typeof ResizeObserver !== 'undefined';
    var ro = hasRO
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target.closest('.ev-bundle-card');
            if (card) syncBundleMedia(card);
          });
        })
      : null;
    cards.forEach(function (card) {
      syncBundleMedia(card);
      if (ro) {
        var body = card.querySelector('.ev-bundle-card__body');
        if (body) ro.observe(body);
      }
    });
    if (!hasRO) {
      window.addEventListener('resize', function () {
        cards.forEach(syncBundleMedia);
      });
    }
  }

  function init() {
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:updated', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart-drawer:opened', init);
})();
